<template>
  <v-dialog v-model="dialog.show" max-width="500" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :single-select="singleSelect"
          :items-per-page="5"
          item-key="id"
          show-select
          :search="search"
          sort-by="ordem"
        >
          <template v-slot:top>
            <v-row dense>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  v-model="search"
                  label="Procurar..."
                  prepend-inner-icon="mdi-magnify"
                />
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.foto="{ item }">
            <v-img
              contain
              max-height="100"
              max-width="100"
              :src="item.foto ? 'data:image/png;base64,' + item.foto : ''"
            ></v-img>
          </template>

          <template v-slot:item.percentual="{ item }">
            <v-text-field
              v-model.number="finanParam.addPercentualTabelaVeic[item.id]"
              :disabled="!selected.some((el) => el.id === item.id)"
              :rules="[rules.required, rules.isNumber]"
              suffix="%"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
          >Voltar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Veiculo from "@/services/veiculo";
import rules from "@/utils/rules";

export default {
  data() {
    return {
      dialog: {
        show: false,
        title: "Adicionar Percentual Sobre Valor Base",
      },
      singleSelect: false,
      selected: [],
      headers: [
        { text: "", value: "foto" },
        { text: "Modelo IHS", value: "modeloIhs" },
        { text: "Percentual", value: "percentual", width: 100 },
      ],
      items: [],
      search: "",
      veiculoService: new Veiculo(),
      finanParam: null,
      rules,
    };
  },

  methods: {
    async show(financiamento) {
      this.finanParam = financiamento;
      if (financiamento.addPercentualTabelaVeic === undefined) {
        this.finanParam.addPercentualTabelaVeic = {};
      }
      await this.getVeiculos();
      this.filtraVeiculosAdicionados();
      this.dialog.show = true;
    },

    async getVeiculos() {
      try {
        this.items = await this.veiculoService.getByEmpresa(
          this.finanParam.empresa
        );
      } catch (error) {
        console.error(error);
      }
    },

    filtraVeiculosAdicionados() {
      Object.keys(this.finanParam.addPercentualTabelaVeic).forEach((key) =>
        this.selected.push(this.items.find((item) => item.id === key))
      );
    },

    close() {
      this.selected = [];
      this.dialog.show = false;
    },
  },
};
</script>
